/**
 * Canonical MenúHunter 2026 mark geometry (runtime source).
 * Design master: design/brand/menuhunter-2026/menuhunter-mark-master.svg
 */

export const MENUHUNTER_BRAND_ORANGE = "#D05A3F";
export const MENUHUNTER_BRAND_NAVY = "#0F172A";
export const MENUHUNTER_BRAND_WHITE = "#FFFFFF";

/**
 * Theme-aware colour for the four outer ring arcs.
 * Dark: white for contrast; light: navy brand.
 * Fork / knife / markers stay {@link MENUHUNTER_BRAND_ORANGE}.
 */
export function menuhunterMarkArcColor(theme: "light" | "dark"): string {
  return theme === "dark" ? MENUHUNTER_BRAND_WHITE : MENUHUNTER_BRAND_NAVY;
}

/** SVG viewBox from the approved master. */
export const MENUHUNTER_MARK_VIEWBOX = {
  width: 545,
  height: 561,
} as const;

/** Stroke width used by the approved master SVG. */
export const MENUHUNTER_MARK_STROKE_MASTER = 9;

/** Thicker stroke for favicon / tiny badge legibility (micro candidate). */
export const MENUHUNTER_MARK_STROKE_MICRO = 13;

/** Broken outer ring segments. */
export const MENUHUNTER_MARK_RING_PATHS = [
  "M 43 236 C 61 143, 133 72, 227 44",
  "M 318 44 C 412 72, 484 143, 502 236",
  "M 502 329 C 486 411, 433 478, 365 511",
  "M 205 513 C 131 486, 61 416, 43 329",
] as const;

/** Four inward-facing triangular markers. */
export const MENUHUNTER_MARK_MARKER_PATHS = [
  "M 250 5 L 294 5 L 272 47 Z",
  "M 540 260 L 500 281 L 540 304 Z",
  "M 250 556 L 294 556 L 272 515 Z",
  "M 5 260 L 45 281 L 5 304 Z",
] as const;

/** Fork strokes. */
export const MENUHUNTER_MARK_FORK_PATHS = [
  `M 184 148 L 184 279
   C 184 303 191 313 202 327
   C 211 339 213 348 212 365
   L 208 507`,
  `M 271 148 L 271 279
   C 271 303 264 313 253 327
   C 244 339 242 348 243 365
   L 247 507`,
  "M 213 149 L 213 266",
  "M 242 149 L 242 266",
] as const;

/** Knife stroke. */
export const MENUHUNTER_MARK_KNIFE_PATH =
  `M 361 508 L 361 160
   C 361 150 357 146 352 146
   C 343 146 337 157 332 169
   C 314 214 304 258 304 298
   C 304 320 309 333 321 343
   C 331 352 334 360 334 379
   L 330 518`;

export const MENUHUNTER_MARK_ALL_PATHS = [
  ...MENUHUNTER_MARK_RING_PATHS,
  ...MENUHUNTER_MARK_MARKER_PATHS,
  ...MENUHUNTER_MARK_FORK_PATHS,
  MENUHUNTER_MARK_KNIFE_PATH,
] as const;

export type MenuHunterMarkVariant = "master" | "micro";

export function menuhunterMarkStrokeWidth(variant: MenuHunterMarkVariant = "master"): number {
  return variant === "micro" ? MENUHUNTER_MARK_STROKE_MICRO : MENUHUNTER_MARK_STROKE_MASTER;
}
